import { useTranslation } from 'react-i18next';
import { AllowedLanguages } from 'i18n';

import { Button } from 'components/Form/Button/Button';
import { ButtonGroup } from 'components/Form/Button/ButtonGroup';

const LANGUAGE_OPTIONS: Array<{ value: AllowedLanguages; label: string; name: string }> = [
  { value: 'en', label: 'EN', name: 'English' },
  { value: 'de', label: 'DE', name: 'Deutsch' },
];

export const EmailLanguageToggle = ({
  value,
  onChange,
}: {
  value: AllowedLanguages;
  onChange: (language: AllowedLanguages) => void;
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-gray-500">
        {t('invoiceVerification:detailsPage.generateDiscrepancyEmail.copyEmailModal.language')}
      </span>
      <ButtonGroup>
        {LANGUAGE_OPTIONS.map((option) => (
          <Button
            key={option.value}
            variant="minimal"
            size="extra-small"
            pressed={value === option.value}
            aria-pressed={value === option.value}
            aria-label={option.name}
            onClick={() => onChange(option.value)}
            analyticsId="invoiceVerification:generateDiscrepancyEmail.changeLanguage"
            analyticsProperties={{ language: option.value }}
          >
            {option.label}
          </Button>
        ))}
      </ButtonGroup>
    </div>
  );
};
